import React from 'react'
import { Link } from 'react-router-dom'
import './Footer.css'

const Footer: React.FC = () => {
  return (
    <footer className="footer">
      <div className="container">
        <div className="footer-grid">
          <div className="footer-section">
            <h3>Contact Information</h3>
            <p>Roll Forming Machine & Die Manufacturing Co. Ltd.</p>
            <p>209 Wilkinson Road, Brampton, ON L6T 4M2</p>
            <p>Phone: <a href="tel:+19057965885">(905) 796-5885</a></p>
            <p>Fax: (905) 796-5471</p>
            <p>Email: <a href="mailto:sales@rollformmachine.com">sales@rollformmachine.com</a></p>
          </div>
          
          <div className="footer-section">
            <h3>Quick Links</h3>
            <ul>
              <li><Link to="/products">Product Catalog</Link></li>
              <li><Link to="/about">About Us</Link></li>
              <li><Link to="/quote">Request Quote</Link></li>
              <li><Link to="/contact">Contact</Link></li>
            </ul>
          </div>
          
        </div>
        
        <div className="footer-bottom">
          <p>&copy; Roll Forming Machine & Die Manufacturing Co. Ltd. All rights reserved.</p>
        </div>
      </div>
    </footer>
  )
}

export default Footer
